module.exports = __webpack_public_path__ + "static/media/PlanoConta1.244c9f90.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadPlanoConta/PlanoConta1.png
// module id = 2200
// module chunks = 0